import { cn } from "@/lib/utils";
import { Loader } from "lucide-react";

const FullscreenLoader = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        "fixed inset-0 flex items-center justify-center bg-background z-50",
        className
      )}
    >
      <div className="flex flex-col items-center gap-2">
        <Loader className="animate-spin size-6 text-foreground" />
        <p className="text-sm">Loading...</p>
      </div>
    </div>
  );
};

export default FullscreenLoader;
